import { render, staticRenderFns } from "./MultiTable.vue?vue&type=template&id=62e042a6&"
import script from "./MultiTable.vue?vue&type=script&lang=ts&"
export * from "./MultiTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports